import React, { useState, useEffect } from 'react';

import { useTime } from '../contexts/TimeContext';

import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    TextField,
    makeStyles
} from '@material-ui/core';

import SyncIcon from '@material-ui/icons/Sync';

const Header = () => {
    const { 
        initialTime,
        baseTime,
        speedMultiplier,
        displayTime,
        setInitialTime,
        setBaseTime,
        setSpeedMultiplier,
        setDisplayTime,
    } = useTime();

    const [showTimePicker, setShowTimePicker] = useState(false);
    const [tempTime, setTempTime] = useState(formatTimeForInput(new Date()));


    function formatTimeForInput(date) {
        return date.toTimeString().substring(0, 5);
    }
    function setCustomTime() {
        if (tempTime) {
            const [hours, minutes] = tempTime.split(':');
            const newDate = new Date();
            newDate.setHours(parseInt(hours, 10));
            newDate.setMinutes(parseInt(minutes, 10));
            newDate.setSeconds(0);

            setBaseTime(newDate);
            setDisplayTime(newDate);
            setInitialTime(Date.now());
            setShowTimePicker(false);
        }
    }

    // 時刻のフォーマット関数
    const formatTime = (date) => {
        return date.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };

    // 表示時刻の更新
    //
    //   表示時刻 (displayTime) = 基準時刻 (baseTime)  + 倍速設定 (speedMultiplier) * 経過秒数
    //   表示時刻は 2025/2/14 16:37〜17:36までとする
    //
    // 基準時刻 (baseTime)
    //
    //      - 画面初期表示時の時刻
    //      - 表示時刻を手動で設定した場合は、その設定時刻
    //
    // 経過秒数
    //
    //   経過秒数 (elapsedSecond) = 現在のunixtime - 画面初期表示時のunixtime (initialTime)
    useEffect(() => {
        const interval = setInterval(() => {
            const elapsedSecond = speedMultiplier * (Date.now() - initialTime);
            let newDisplayTime = new Date(baseTime.getTime() + elapsedSecond);
            if (newDisplayTime > new Date(2025, 2, 14, 17, 36)) {
              newDisplayTime = new Date(2025, 2, 14, 16, 37);
              setBaseTime(newDisplayTime);
              setInitialTime(Date.now());
            }

            setDisplayTime(newDisplayTime);
        }, 3000); // 滑らかな更新のため短い間隔を設定

        return () => clearInterval(interval);
    }, [baseTime, initialTime, speedMultiplier]);

    // 倍速変更ハンドラー
    const handleSpeedChange = (e) => {
        setSpeedMultiplier(Number(e.target.value));

        // 変更時点の表示時刻からの経過秒数を求めるために
        // このタイミングのunixtimeを記録する
        setInitialTime(Date.now());
        setBaseTime(displayTime);
    };

    const resetTime = () => {
        setBaseTime(new Date(2025, 2, 14, 17, 0, 0));
        setDisplayTime(new Date(2025, 2, 14, 17, 0, 0));
        setInitialTime(Date.now());
    }

    const classes = makeStyles((theme) => ({
        dialogTitle: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        formField: {
            marginBottom: theme.spacing(2),
            width: '100%'
        },
        buttonContainer: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: theme.spacing(1)
        },
        iconButton: {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.light,
            marginRight: theme.spacing(1),
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText
            }
        }
    }));
    return (
        <header>
            <div className="ly_header">
                <div className="bl_title">
                    <div className="el_leftIcon">
                        <img src="/img/header_leftIcon.png" alt="" />
                    </div>
                    <div className="el_mainTitle">
                        <h1><a href="/">除雪関連情報共有サイト</a></h1>
                    </div>
                    <div className="el_rightIcon">
                        <img src="/img/header_rightIcon.png" alt="" />
                    </div>
                </div>
                <div className="bl_input">
                    <a href="/form"><img src="/img/form_button.png" alt="" /></a>
                </div>
                <div className="bl_control py-2 px-4 border-b flex justify-between items-center">
                    <div className="flex items-center bg-white rounded-lg shadow-sm px-2 py-2 ly_timeCtl">
                        <div className="bl_timeCtlRow">
                            <div className="flex items-center">
                                <span className="font-bold text-gray-700 mr-2">2025年2月14日 夕方の映像</span>
                            </div>
                        </div>
                        <div className="bl_timeCtlRow">
                            <div className="flex items-center">
                                <span className="text-gray-700 mr-2">表示時刻:</span>
                                <span className="font-bold text-blue-800">{formatTime(displayTime)}</span>
                            </div>

                            <div className="flex items-center bl_ttlDay">
                                <span className="text-gray-700 mr-2">倍速:</span>
                                <select 
                                    className="border rounded p-1"
                                    value={speedMultiplier}
                                    onChange={handleSpeedChange}
                                >
                                    <option value="1">1倍速</option>
                                    <option value="2">2倍速</option>
                                    <option value="4">4倍速</option>
                                    <option value="60">60倍速</option>
                                </select>
                            </div>
                        </div>
                        <div className="bl_timeCtlRow">
                            <div className="flex items-center space-x-2">
                                <button 
                                    onClick={resetTime} 
                                    className="el_timeCtlBtn"
                                >
                                    <SyncIcon />
                                    リセット
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Time Picker Modal */}
                <Dialog
                    open={showTimePicker}
                    onClose={() => setShowTimePicker(false)}
                    aria-labelledby="time-selection-dialog-title"
                >
                    <DialogTitle id="time-selection-dialog-title" className={classes.dialogTitle}>
                        表示時刻の指定
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            label="時刻"
                            type="time"
                            value={tempTime}
                            onChange={(e) => setTempTime(e.target.value)}
                            className={classes.formField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                step: 60, // 1分単位
                            }}
                            margin="dense"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowTimePicker(false)} color="default">
                            キャンセル
                        </Button>
                        <Button onClick={setCustomTime} color="primary" variant="contained">
                            設定
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </header>
    );
};

export default Header;
